import { apiRegistro, apiCallCenterOperador } from '@/plugins/axios'

export default {
  postUser(user) {
    return apiRegistro().post('/login', user)
  },

  loginOperador(data) {
    return apiCallCenterOperador().post('/agent/login', data)
  },
}
